import React from 'react';

const ErrorBox = ({ id, hidden, errors = [], isFull }) => {
  return (
    <div id={id} className={`t-box -error ${(isFull ? '' : '-half', hidden ? 'hide' : '')}`}>
      <h2>{'ผิดพลาด'}</h2>
      {errors.map((msg, index) => (
        <li key={index}>{msg}</li>
      ))}
    </div>
  );
};

export default ErrorBox;
